module.exports = __webpack_public_path__ + "img/pic_14.31290915.jpg";